import { createSelector } from "reselect";

const supplierPrivateInquiriesStateSelector = (state) =>
  state.mySupplierPrivateInquiries;

const selectById = (state, itemId) => itemId;

export const supplierPrivateInquiriesSelector = createSelector(
  [supplierPrivateInquiriesStateSelector],
  (inquiries) => inquiries.items
);

export const supplierProposalsSelector = createSelector(
  [supplierPrivateInquiriesStateSelector],
  (proposals) => proposals.proposals
)


export const inquiryByIdSelector = createSelector(
  [supplierPrivateInquiriesSelector, selectById],
  (inquiries, _id) => {
    console.log(inquiries)
    const inquiry = inquiries.find((item) => _id === item._id);
    if (!inquiry) return null;
    return inquiry;
  }
);

export const supplierPrivateInquiriesIsLoadingSelector = createSelector(
  [supplierPrivateInquiriesStateSelector],
  (inquiries) => inquiries.isLoading
);

export const supplierPrivateInquiriesCount = createSelector(
  [supplierPrivateInquiriesStateSelector],
  (inquiries) => inquiries.count
)



export const proposalById = createSelector(
  [supplierProposalsSelector, selectById],
   (inquiries, _id) => {
    console.log(inquiries)
    const inquiry = inquiries.find((item) => _id === item._id);
    if (!inquiry) return null;
    return inquiry;
  }
)
